<template>
  <v-main>
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    <v-container fluid>
      <v-card>
        <v-card-title> Hubungi Kami </v-card-title>
        <v-fab-transition>
          <v-btn
            v-if="isEditable == 0"
            class="mt-8 mr-4"
            color="pink"
            dark
            absolute
            top
            right
            fab
            @click="changeEditable"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-fab-transition>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          class="pl-4 pr-4 pt-4"
        >
          <v-row dense>
            <v-col cols="12">
              <v-row dense>
                <v-col cols="12" sm="12" md="6">
                  <v-textarea
                    v-model="dataRs.deskripsi"
                    label="Hubungi Kami"
                    rows="12"
                    row-height="15"
                    outlined
                    dense
                    :readonly="isEditable == 0"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-textarea
                    v-model="dataRs.deskripsi_en"
                    label="Hubungi Kami Inggris"
                    rows="12"
                    row-height="15"
                    outlined
                    dense
                    :readonly="isEditable == 0"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                v-if="isEditable == 1"
                style="margin-right: 10px"
                @click="doBatal"
              >
                Batal
              </v-btn>
              <v-btn
                v-if="isEditable == 1"
                dark
                color="primary"
                type="button"
                @click="doSubmit"
              >
                Simpan
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-container>
  </v-main>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import HubungiKamiService from "../../services/HubungiKamiService";
import CommonService from "../../services/CommonService";

// --- Template Refs ---
const form = ref(null); // Corresponds to ref="form" on v-form

// --- Reactive State ---
const isEditable = ref(0);
const valid = ref(true);
const id = ref(null);
const dataRs = reactive({
  deskripsi: "",
  deskripsi_en: "",
});

// --- Static Data ---
const breadcrumbs = [
  {
    text: "Web Content",
    disabled: false,
    exact: true,
    to: { name: "/webcontent/hubungi-kami" },
  },
  { text: "Hubungi Kami", disabled: true },
];

// --- Functions ---
const changeEditable = () => {
  isEditable.value = 1;
};

const getHubungiKami = async () => {
  try {
    const res = await HubungiKamiService.getHubungiKami();
    if (res.data.data) {
      // Assign properties to the reactive object
      Object.assign(dataRs, res.data.data);
      id.value = res.data.data.id;
    }
  } catch (err) {
    console.error(err);
  }
};

const doBatal = () => {
  isEditable.value = 0;
  getHubungiKami(); // Re-fetch original data
};

const doSubmit = async () => {
  // const { valid } = await form.value.validate();
  // if (!valid) {
  //   window.scrollTo(0, 0);
  //   return;
  // }

  try {
    await HubungiKamiService.update(dataRs, id.value);
    isEditable.value = 0;
    CommonService.showSuccessToast("Update Data berhasil");
    getHubungiKami();
  } catch (err) {
    console.error(err);
    CommonService.showErrorToast("Update data gagal. Coba lagi");
  }
};

// --- Lifecycle Hooks ---
onMounted(async () => {
  await getHubungiKami();
});
</script>

<style scoped></style>
